import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule, TitleCasePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { GoBackComponent } from './components/go-back/go-back.component';
import { ExportButtonComponent } from './components/export-button/export-button.component';
import { EmptyDatatableComponent } from './components/datatable/empty-datatable/empty-datatable.component';
import { CurrencyCodePipe } from './pipes/currency-code.pipe';
import { UserRolePipe } from './pipes/user-role.pipe';
import { UserRoleDirective } from './directives/userRole.directive';
import { SubRoleDirective } from './directives/subRole.directive';
import { ClickOutsideDirective } from './directives/click-outside.directive';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { PageSizeComponent } from './components/datatable/page-size/page-size.component';
import { PaginationComponent } from './components/datatable/pagination/pagination.component';
import { PageTitleComponent } from './components/page-title/page-title.component';
import { TruncatePipe } from './pipes/truncate.pipe';
import { SearchFilterComponent } from './components/datatable/search-filter/search-filter.component';
import { UppercaseDirective } from './directives/uppercase.directive';
import { DropdownAppendToBodyDirective } from './directives/dropdown-append-to-body.directive';
import { GenericTableComponent } from './components/datatable/generic-table/generic-table.component';
import { DragAndDropFileComponent } from './components/drag-and-drop-file/drag-and-drop-file.component';
import { ChannelPipe } from './pipes/channel.pipe';
import { LoaderComponent } from './components/loaders/loader/loader.component';
import { FullLoaderComponent } from './components/loaders/full-loader/full-loader.component';
import { TableSkeletonComponent } from './components/loaders/table-skeleton/table-skeleton.component';
import { CountryPipe } from './pipes/country.pipe';
import { ServiceTypePipe } from './pipes/service-type.pipe';
import { ClientDocumentStatusClassPipe, ClientDocumentStatusLabelPipe } from './pipes/client-document-status.pipe';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { DropdownModule } from 'primeng/dropdown';
import { TooltipModule } from 'primeng/tooltip';
import { ChipsModule } from 'primeng/chips';
import { InputNumberModule } from 'primeng/inputnumber';
import { EditorModule } from 'primeng/editor';
import { ChartLegendInfoComponent } from './components/chart-legend-info/chart-legend-info.component';
import { TooltipInfoComponent } from './components/tooltip-info/tooltip-info.component';
import { ClientPaymentCategoryPipe } from './api-services/cms/pipes/client-payment-Category.pipe';
import { ConsentDeliveryChannelPipe, ConsentPeriodPipe } from './api-services/consent/pipes';
import { OtpChannelLabelsPipe } from './api-services/otp/pipes/otp-channel-labels.pipe';
import { PasswordStrengthComponent } from './components/password-strength/password-strength.component';
import { CountryFlagComponent } from './components/country-flag/country-flag.component';
import { RequestTypeIconComponent } from './components/request-type-icon/request-type-icon.component';
import { SubUsersTableComponent } from './components/sub-users-table/sub-users-table.component';
import { SubUsersSectionComponent } from './components/sub-users-section/sub-users-section.component';
import { SearchFilterDesktopComponent } from './components/datatable/search-filter/search-filter-desktop/search-filter-desktop.component';
import { ProfileDocsReminderComponent } from './components/profile-docs-reminder/profile-docs-reminder.component';
import { IpWhitelistAttentionComponent } from './components/ip-whitelist-attention/ip-whitelist-attention.component';
import { PhoneNumberInputComponent } from './components/phone-number-input/phone-number-input.component';

@NgModule({
  declarations: [
    PageSizeComponent,
    PaginationComponent,
    PageTitleComponent,
    SearchFilterComponent,
    TruncatePipe,
    ClickOutsideDirective,
    UppercaseDirective,
    DropdownAppendToBodyDirective,
    UserRoleDirective,
    SubRoleDirective,
    BreadcrumbComponent,
    GoBackComponent,
    ExportButtonComponent,
    EmptyDatatableComponent,
    CurrencyCodePipe,
    UserRolePipe,
    GenericTableComponent,
    DragAndDropFileComponent,
    ChannelPipe,
    LoaderComponent,
    FullLoaderComponent,
    TableSkeletonComponent,
    CountryPipe,
    ServiceTypePipe,
    ChartLegendInfoComponent,
    TooltipInfoComponent,
    ClientPaymentCategoryPipe,
    OtpChannelLabelsPipe,
    ConsentPeriodPipe,
    ConsentDeliveryChannelPipe,
    PasswordStrengthComponent,
    CountryFlagComponent,
    RequestTypeIconComponent,
    SubUsersTableComponent,
    SubUsersSectionComponent,
    SearchFilterDesktopComponent,
    ProfileDocsReminderComponent,
    IpWhitelistAttentionComponent,
    PhoneNumberInputComponent,
    ClientDocumentStatusClassPipe,
    ClientDocumentStatusLabelPipe
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    InputTextModule,
    DropdownModule,
    TooltipModule
  ],
  exports: [
    InputTextModule,
    InputTextareaModule,
    DropdownModule,
    TooltipModule,
    ChipsModule,
    EditorModule,
    InputNumberModule,
    PageSizeComponent,
    PaginationComponent,
    PageTitleComponent,
    SearchFilterComponent,
    TruncatePipe,
    BreadcrumbComponent,
    GoBackComponent,
    ExportButtonComponent,
    EmptyDatatableComponent,
    ClickOutsideDirective,
    UppercaseDirective,
    DropdownAppendToBodyDirective,
    UserRoleDirective,
    SubRoleDirective,
    CurrencyCodePipe,
    UserRolePipe,
    CommonModule,
    GenericTableComponent,
    DragAndDropFileComponent,
    ChannelPipe,
    LoaderComponent,
    FullLoaderComponent,
    TableSkeletonComponent,
    CountryPipe,
    ServiceTypePipe,
    ChartLegendInfoComponent,
    TooltipInfoComponent,
    ClientPaymentCategoryPipe,
    OtpChannelLabelsPipe,
    ConsentPeriodPipe,
    ConsentDeliveryChannelPipe,
    PasswordStrengthComponent,
    CountryFlagComponent,
    RequestTypeIconComponent,
    SubUsersTableComponent,
    SubUsersSectionComponent,
    SearchFilterDesktopComponent,
    ProfileDocsReminderComponent,
    IpWhitelistAttentionComponent,
    PhoneNumberInputComponent,
    ClientDocumentStatusClassPipe,
    ClientDocumentStatusLabelPipe
  ],
  providers: [
    TitleCasePipe
  ]
})
export class SharedModule { }
